import { useReactTable, getCoreRowModel, flexRender, getPaginationRowModel } from '@tanstack/react-table';
import tableStyles from '../styles/tableStyles';
import TablePagination from './Pagination';
import clsx from 'clsx';
const DataList = ({ data = [], columns, pagination, onPageChange, onPageSizeChange }) => {
    const {page, limit, totalCount  } = pagination;
    const totalPages = Math.ceil(totalCount / limit);
    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        manualPagination: true,
        pageCount: totalPages,
        
    });

    return (
        <div className={clsx('box p-4 overflow-x-auto intro-y', 
        'lg:overflow-x-auto', 'col-span-12' , 'bg-white dark:bg-gray-800',
        'border-2 border-gray-200 dark:border-gray-600 rounded-lg',
        'shadow-md'
        )}>
            <table className={clsx(
                'border-spacing-y-[2px] border-separate -mt-0 w-full',
                'border-gray-200/60',
                'font-medium text-gray-800 bg-white',
                'dark:bg-gray-800 dark:border-gray-600 dark:text-gray-100',
                'p-2 whitespace-nowrap'
            )}>
                <thead>
                    {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map((header) => (
                                <th key={header.id} className={tableStyles.headerCell}>
                                    {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {table.getRowModel().rows.map((row) => (
                        <tr key={row.id} className="intro-x animate-fade-in-up opacity-0">
                            {row.getVisibleCells().map((cell) => (
                                <td key={cell.id} className={tableStyles.bodyCell}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
            <TablePagination totalPages={totalPages} page={page} limit={limit} onPageChange={onPageChange} onPageSizeChange={onPageSizeChange} tableStyles={tableStyles} />
        </div>
    );
};

export default DataList;
